// extracted by mini-css-extract-plugin
export default {"accBaseDialog":"BaseDialog_accBaseDialog__P4ZzO"};